import { createFileRoute } from '@tanstack/react-router';

import { Error500 } from '@/templates/Error500/Error500';

/**
 * Route
 */
export const Route = createFileRoute('/500')({
  component: () => <Error500 />,
});
